import { REF_SIZE, REF_SIZE_PT, SIZE_OPTIONS } from '../../../../../constants/size';
import { FONTS } from '../../../../../constants/fonts';

export const getTitleMetrics = (orientation) => {
    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            fontFamily: FONTS.ITALIC,
            fontSize: 45,
            lineHeight: 1.07,
            width: REF_SIZE.w * 0.73
        };
    }

    return {
        fontFamily: FONTS.ITALIC,
        fontSize: 30,
        lineHeight: 1.07,
        width: REF_SIZE_PT.w * 0.2
    };
};

export const getSocialMetrics = (orientation) => {
    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            isUpperCase: true,
            fontFamily: FONTS.REGULAR,
            fontSize: 45,
            lineHeight: 1.07,
            width: REF_SIZE.w * 0.23
        };
    }

    return {
        isUpperCase: true,
        fontFamily: FONTS.REGULAR,
        fontSize: 30,
        lineHeight: 1.07,
        width: REF_SIZE_PT.w * 0.5
    };
};
